var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import MissingPage from '@patternfly/react-component-groups/dist/dynamic/MissingPage';
var isBeta = function () { return (window.location.pathname.split('/')[1] === 'beta' ? '/beta' : ''); };
var InvalidObject = function (props) { return (_jsx(MissingPage, __assign({ toHomePageUrl: "".concat(window.location.origin).concat(isBeta()) }, props))); };
export default InvalidObject;
//# sourceMappingURL=InvalidObject.js.map